import api from './api';
import type { Service, ServiceCategory, ServiceType } from '../types';

class ServicesService {
  /**
   * Get all service categories
   */
  async getCategories(): Promise<ServiceCategory[]> {
    const response = await api.get<{
      success: boolean;
      data?: ServiceCategory[];
      error?: string;
    }>('/public/servicos/categorias');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar categorias');
  }

  /**
   * Get all services
   */
  async getServices(): Promise<Service[]> {
    const response = await api.get<{
      success: boolean;
      data?: Service[];
      error?: string;
    }>('/public/servicos');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar serviços');
  }

  /**
   * Get services by category
   */
  async getServicesByCategory(categoryId: string): Promise<Service[]> {
    const response = await api.get<{
      success: boolean;
      data?: Service[];
      error?: string;
    }>(`/public/servicos?categoria=${categoryId}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar serviços da categoria');
  }

  /**
   * Get services by type
   */
  async getServicesByType(typeId: string): Promise<Service[]> {
    const response = await api.get<{
      success: boolean;
      data?: Service[];
      error?: string;
    }>(`/public/servicos?tipo=${typeId}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar serviços do tipo');
  }

  /**
   * Get service types
   */
  async getServiceTypes(): Promise<ServiceType[]> {
    const response = await api.get<{
      success: boolean;
      data?: ServiceType[];
      error?: string;
    }>('/public/servicos/tipos');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar tipos de serviço');
  }

  /**
   * Get service details
   */
  async getServiceDetails(serviceId: string): Promise<Service> {
    const response = await api.get<{
      success: boolean;
      data?: Service;
      error?: string;
    }>(`/public/servicos/${serviceId}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar detalhes do serviço');
  }
}

export default new ServicesService();
